import React from "react";
import { Box, Flex, Heading, Image, Link, Span, Text, } from "@catchoftheday/cg-components";
import { useTheme } from "@catchoftheday/theme";
import { ASSET_PERSON_ONEPASS_FIREWORKS, URL_ONEPASS_TERMS_AND_CONDITIONS, } from "../../../../consts";
import { TransferCTAButton } from "../TransferCTAButton";
export const HeaderBanner = () => {
    const theme = useTheme();
    return (<Box backgroundColor="onePass.textPrimary" pt={{
            xs: 10,
            md: 0,
        }} color="white">
      <Flex maxWidth={theme.maxWidths.cotdWebsite} px={4} flexWrap="wrap" alignItems="center" margin="0 auto">
        <Box width={{
            xs: "100%",
            md: "50%",
        }} pr={{
            xs: 0,
            md: 5,
        }}>
          <Heading.h1 fontSize={{
            xs: "2xl",
            md: "3xl",
        }} fontWeight="bold" mb={6}>
            Transfer your OnePass subscription for access to all participating
            brands
          </Heading.h1>
          <Text mb={6} fontWeight="medium">
            The OnePass membership provider is changing from Catch to Wesfarmers
            to bring you more benefits. Follow the steps to securely transfer
            your subscription to the new OnePass.
          </Text>
          <TransferCTAButton />
          <Span display="block" textAlign="center" fontWeight="medium" fontSize="base" mb={4}>
            <Link color="inherit" hoverColor="inherit" fontWeight="bold" textDecoration="underline" href={URL_ONEPASS_TERMS_AND_CONDITIONS}>
              Terms &amp; Conditions
            </Link>{" "}
            and{" "}
            <Link href="/privacy" color="inherit" hoverColor="inherit" fontWeight="bold" textDecoration="underline">
              Privacy Policy
            </Link>
          </Span>
        </Box>
        <Box width={{
            xs: "100%",
            md: "50%",
        }} pl={{
            xs: 0,
            md: 5,
        }} alignSelf="flex-end">
          <Image alt="Person laughing with OnePass-themed fireworks in the background" src={ASSET_PERSON_ONEPASS_FIREWORKS} width="100%" height="auto"/>
        </Box>
      </Flex>
    </Box>);
};
